export const filters = [
  'ats_job_opening_statuses',
  'ats_recruiter',
  'ats_hiring_manager',
  'location_id',
  'employment_type_id',
  'business_unit_id',
  'departments',
]
